import { render, staticRenderFns } from "./PieTDWidget.vue?vue&type=template&id=da5a1bea&scoped=true"
import script from "./PieTDWidget.vue?vue&type=script&lang=js"
export * from "./PieTDWidget.vue?vue&type=script&lang=js"
import style0 from "./PieTDWidget.vue?vue&type=style&index=0&id=da5a1bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5a1bea",
  null
  
)

export default component.exports